import Analitica from '@/vendor/analitica.vendor'

import routeHome from './home.route'
import routeRecipients from './recipients.route'
import routeCustomer from './customer.route'
import routeFinancial from './financial.route'
import routeContracts from './contracts.route'
import routeReceivablesRegister from './receivables-register.route'
import routeWebhook from './webhooks.route'
import routePhysicalWorld from './physical-world.route'
import routeSales from './sales'
import routeRecurrence from './recurrence'
import routeTeam from './team'
import routeSettings from './settings'
import routeKyc from './kyc.route'
import { isGateway } from '../enums/business-model.enum'
import experimentSingleton from '../vendor/experiment.vendor'
import Appcues from '../vendor/appcues.vendor'
import { applyStoneRebrandFavicon } from '../utils/stone-rebrand-favicon.utils'

const routeMain = store => ({
  path: '/:merchant_id/:account_id',
  component: () =>
    import(
      /* webpackChunkName: "motherboard" */ '@/components/project/templates/Motherboard.vue'
    ),
  beforeEnter: async (to, from, next) => {
    if (store.getters.maintenance) {
      next({ name: 'maintenance' })
      return
    }

    const { merchant_id: merchantId, account_id: accountId } = to.params
    const params = { merchant_id: merchantId, account_id: accountId }

    if (!merchantId?.includes('merch_') || !accountId?.includes('acc_')) {
      next({ name: 'default' })
      return
    }

    if (!store.getters.profile) {
      await store.dispatch('GET_AUTHORIZATION', params)
    }

    if (!isGateway(store.getters.businessModel)) {
      await store.dispatch('GET_COMPANY_ID', params)
    }

    if (!store.getters.kyc) {
      await routeKyc({ store, params, next })
    }

    if (!store.getters.merchantSummary) {
      await store.dispatch('GET_MERCHANT_SUMMARY', merchantId)
    }

    await store.dispatch('GET_ACCOUNT_SUMMARY', params) // required shop.account:get

    /*
     * TODO:
     * Esse get deve ser feito dentro do created do componente SecretKeys.vue,
     * após todas as merchants com chaves depreciadas efetuarem o reset de chaves secretas.
     * O Monteiro ficou resposável por trazer o dado de quando não será mais necessário essa solução.
     * Data da implementação: 2024-07-24
     * Responsáveis: @Trocatti, @Pedro Henrique Lourenco Monteiro e @Léo Martins
     */
    await store.dispatch('GET_SECRET_KEY') // required deprecated keys

    Analitica.updateMetadata({
      user: {
        merchant_id: store.getters.merchantId,
        account_id: store.getters.accountId,
        user_email: store.getters.profile?.user?.email
      }
    })

    await experimentSingleton.setUpUser({
      pagarmeCompanyId: store.getters.pagarmeCompanyId,
      accountId: store.getters.accountId
    })

    applyStoneRebrandFavicon()

    Appcues.updateMetadata({
      userId: store.getters.profile?.user?.id,
      companyId: store.getters.pagarmeCompanyId,
      merchantId: store.getters.merchantId,
      accountId: store.getters.accountId,
      accountType: store.getters.account.accountType,
      accountName: store.getters.account.name,
      userEmail: store.getters.profile?.user?.email,
      businessModel: store.getters.businessModel
    })

    next()
  },
  children: [
    () => ({
      path: '',
      name: 'motherboard',
      redirect: { name: 'home' }
    }),
    routeHome,
    routeSettings,
    routePhysicalWorld,
    ...routeSales,
    ...routeRecurrence,
    ...routeTeam,
    ...routeCustomer,
    ...routeRecipients,
    ...routeFinancial,
    ...routeContracts,
    ...routeReceivablesRegister,
    ...routeWebhook
  ].map(item => item(store))
})

export default routeMain
